export const initialState = {
    entities: [],
    count: 0,
};
